import React from "react";
import { useApp } from "../context/AppContext";
import { CoverageHeatmap } from "../components/CoverageHeatmap";
import { DayNavigator } from "../components/DayNavigator";
import { PageHeader } from "../components/PageHeader";

export default function CoveragePage() {
  const { config, workstations, schedule, selectedDay } = useApp();
  if (!config) return null;

  return (
    <div className="animate-fadeup">
      <PageHeader
        title="Coverage Heatmap"
        subtitle="Staffing status of every workstation requirement for the selected day. Green = covered, red = unstaffed (brighter for higher priority)."
      />
      <DayNavigator />
      <CoverageHeatmap config={config} workstations={workstations} schedule={schedule} day={selectedDay} />
    </div>
  );
}
